import React from 'react';
import { Box, Typography } from '@mui/material';
import './test-calculations.css';

const TestCalculations: React.FC = () => {
  return (
    <Box className="test-calculations" 
         data-a4-height="297mm" 
         data-available="140px" 
         data-row-height="5.6px">
      <Box className="test-header">
        Header (40px)
      </Box>
      <Box className="test-content">
        <Box className="test-main-table">
          Main Table (Dynamic - uses remaining space)
        </Box>
        <Box className="test-hsn-table">
          HSN Table (28px - 5 rows × 5.6px)
        </Box>
      </Box>
      <Box className="test-footer">
        Footer (117px)
      </Box>
    </Box>
  );
};

export default TestCalculations;
